import { AuthUser } from '@excelway/types/auth-user.types';

export interface State {
  user: AuthUser | null;
}

export const initialState: State = {
  user: null,
};
